import { ArrowRightSmall } from '@peacecover/icon';
import { useTranslation } from 'react-i18next';

type TypeModalItemProps = {
  type: { id: string; description: string }
  onSelect: (typeId: string) => void
}

const TypeModalItem = ({ type, onSelect }: TypeModalItemProps) => {
  const { t } = useTranslation('contact')
  return (
    <li
      onClick={() => onSelect(type.id)}
      className="flex items-center justify-between cursor-pointer px-5 py-4 hover:bg-surface-light"
    >
      <div>
        <p className="font-pretendard-semibold text-[17px] text-main-light-1 dark:text-main-dark-1">
          {t(`contact_category.${type.id}`)}
        </p>
        <p className="font-pretendard-regular text-sm text-main-light-3 dark:text-main-dark-3">
          {t(`contact_category.${type.description}`)}
        </p>
      </div>
      <ArrowRightSmall size={24} className='text-text-main-lv3' />
    </li>
  )
}

export default TypeModalItem
